import Animation from './animation'
import * as shape from 'd3-shape'

/*
 * This animation is used points ticks are added and/or removed
 * from the x-axis. Points rotate
 */
class RotatingAnimation extends Animation {

  constructor (options) {
    super(options)

    this.previousLineGenerator = shape.radialLine()

    this.previousLineGenerator.curve(shape.curveCatmullRomClosed.alpha(.5))
                              .angle((d, i) => {
                                return this.previous.scalers.x.groupScale(d.rangeId, i)
                              })
                              .radius((d, i) => {
                                return this.previous.yScale(d.raw, i)
                              })
  }

  match (series) {
    return false // Not yet supported
    if (!this.previous.scalers.x || this.seriesChanged) {
      // We don't have previous data or series changed, so we're not rotating points
      return false
    }

    let domain0 = this.previous.scalers.x.groupScale.domain()
      , domain1 = this.scalers.x.groupScale.domain()

    return domain0[0] !== domain1[0] || // Start ticks don't match
           domain0[domain0.length - 1] !== domain1[domain1.length - 1] // End ticks don't match
  }

  animate (serie, entering, selection, merged, exiting) {
    // merged.selection()
    //       .selectAll('path')
    //       .data(() => {
    //         return [serie.points, serie.points]
    //       })
    //       .attr('d', this.lineGenerator)
    // // path.attr('d', this.lineGenerator)
    // return
    // Determine how many ticks we lost or gained on both sides
    let domain0 = this.previous.scalers.x.groupScale.domain()
      , domain1 = this.scalers.x.groupScale.domain()
      , firstIdx = domain1.indexOf(domain0[0])
      , lastIdx = domain1.indexOf(domain0[domain0.length - 1])
      , ticks0 = domain1.filter((tick, idx) => idx < firstIdx).length
      , ticks1 = domain1.filter((tick, idx) => idx > lastIdx).length

    // We know how many ticks were added on each side.
    // Update the old path, so the control points match.
    let previousPoints = merged.selection().selectAll('path').datum()
      , newTicks0 = new Array(ticks0).fill(previousPoints[0])
      // , newTicks1 = new Array(ticks1).fill(previousPoints[previousPoints.length - 1])
      , newTicks1 = new Array(ticks1).fill(previousPoints[0])

    // console.log(previousPoints)
    // console.log(newTicks0)
    // console.log(newTicks1)
      // console.log(data)
      // previousPoints.shift()
      // console.log('first', [...newTicks0, ...previousPoints, ...newTicks1])
    // Update the path, this shouldn't make any visual updates to the screen, just
    // updates the `path` control points
    selection.selectAll('path')
             .data([[...newTicks0, ...previousPoints, ...newTicks1]])
             .attr('d', this.previousLineGenerator)

    // Now we need to animate the path to its new location.
    // Determine how many ticks were removed from each side
    let removedIdx0 = domain0.indexOf(domain1[0])
      , removedIdx1 = domain0.indexOf(domain1[domain1.length - 1])
      , removedCount0 = removedIdx0 !== -1 ? domain1.filter((tick, idx) => idx < removedIdx0).length : 0
      , removedCount1 = removedIdx1 !== -1 ? domain1.filter((tick, idx) => idx > removedIdx1).length : 0
      , removedTicks0 = new Array(removedCount0).fill(serie.points[0])
      , removedTicks1 = new Array(removedCount1).fill(serie.points[serie.points.length - 1])

    // console.log('moving to', [...newTicks0, ...serie.points, ...removedTicks1])
return
    merged.selectAll('path')
          .attr('d', () => {
            // console.log(removedTicks0, removedTicks1)
            // let ticks = [...newTicks, ...serie.points, ...removedTicks1]
            let ticks = [serie.points[serie.points.length - 1], ...serie.points]
            // console.log(ticks)
            return this.lineGenerator(ticks)
          })
          .end().then(() => {
            // return
            // console.log(serie.points)
            let points = serie.points
            // points.unshift(serie.points[0])
            merged.selection()
                  .selectAll('path')
                  .data([points, points])
                  .attr('d', this.lineGenerator)
          })
  }

}

export default RotatingAnimation
